import React, {useState, useEffect} from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';
import {Button, Select} from 'components/antd';
import {User} from 'api';

type Props = {
  isOpen: boolean;
  setModal: (isOpen: boolean) => void;
  users: User[];
  assignedUsers: User[];
  setAssignedUsers: React.Dispatch<React.SetStateAction<User[]>>;
};

export default ({
  isOpen,
  setModal,
  users,
  assignedUsers,
  setAssignedUsers,
}: Props) => {
  const [tmpAssignedUsers, setTmpAssignedUsers] = useState<User[]>([]);

  useEffect(() => {
    setTmpAssignedUsers(assignedUsers);
  }, [assignedUsers]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => {
        setModal(false);
      }}
      style={{
        overlay: {
          background: 'rgba(13, 24, 59, 0.6)',
        },
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          padding: '0',
          borderRadius: '10px',
          width: '518px',
          boxShadow: '0px 0px 20px rgba(73, 80, 88, 0.26)',
          overflowY: 'scroll',
        },
      }}
      contentLabel="modal">
      <ModalHeader>
        <h2>メンバーを追加</h2>
      </ModalHeader>
      <ModalBody>
        <Select
          dropdownMatchSelectWidth={false}
          mode="multiple"
          allowClear
          value={tmpAssignedUsers.map((user) => user.id) || []}
          placeholder="メンバーを選択"
          optionFilterProp="children"
          onChange={(value) =>
            setTmpAssignedUsers(users.filter((user) => value.includes(user.id)))
          }>
          {users.map((user) => (
            <Select.Option
              value={user.id}
              key={user.id}
              label={
                <React.Fragment>
                  &nbsp; {user.lastName} {user.firstName}
                </React.Fragment>
              }>
              &nbsp; {user.lastName} {user.firstName}
            </Select.Option>
          ))}
        </Select>
        <div className="flex mt-4">
          <Button
            type="primary"
            className="ml-auto w-[120px]"
            disabled={tmpAssignedUsers.length === 0}
            onClick={() => {
              setAssignedUsers(tmpAssignedUsers);
              setModal(false);
            }}>
            追加
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

const ModalHeader = styled.div`
  display: flex;
  padding: 2rem 3rem 0;
  position: relative;

  h2 {
    font-weight: bold;
    font-size: 17.5px;
  }

  button {
    top: 1.5rem;
    right: 1rem;
    box-shadow: none;
    border: none;
    margin-left: auto;
    svg {
      margin: auto 0;
      height: 16px;
      width: 25px;
      path {
        fill: var(--text-color-3);
      }
    }

    span {
      margin: auto 0;
      color: var(--text-color-3);
    }
  }
`;

const ModalBody = styled.div`
  padding: 0rem 3rem 2rem;
  display: flex;
  flex-direction: column;

  > * {
    &:nth-child(1) {
    }
    &:nth-child(2) {
      margin-top: 19px;

      .ant-select-selector {
        height: 40px;
      }
    }
    &:nth-child(3) {
      margin-left: auto;
      margin-top: 31px;
      width: 128px;
    }
  }
`;
